// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3DJ-u","title":"ClientCherryInfo_title__1C7nS","itemText":"ClientCherryInfo_itemText__2uW4V"};